import { render, staticRenderFns } from "./ModalExibicaoMultiplasNdsDados.vue?vue&type=template&id=2aa4a746"
import script from "./ModalExibicaoMultiplasNdsDados.vue?vue&type=script&lang=js"
export * from "./ModalExibicaoMultiplasNdsDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports